var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.599,
    height: 49,
    viewBox: "0 0 32.599 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dropdown_for_input",
    "data-name": "Dropdown for input",
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Drop",
    transform: "translate(18.9 21.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Drop-2",
    "data-name": "Drop",
    d: "M2299.484,477.188h13.2l-6.8,8.5Z",
    transform: "translate(-2299.484 -477.188)",
    fill: "#2d335d"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_349",
    "data-name": "Line 349",
    y2: 49,
    fill: "none",
    stroke: "#e8e8e8",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown-arrow.40b081146d13f22feb777ad3d7ca6abb.svg";
export { ForwardRef as ReactComponent };